export const ENDPOINT = {
  SSE_CONNECTION: '/sse/connection',
  GET_NOTIFICATION: '/notification',
  GET_NOTIFICATIONS_FILTER: '/notifications/filter',
  GET_NOTIFICATION_COUNT: '/notifications/count',
  MARK_AS_READ_NOTIFICATION: '/notification/mark-as-read',
  MARK_ALL_AS_READ_NOTIFICATION: '/notifications/mark-as-read',
  SUBSCRIBE_NOTIFICATION: '/notifications/subscribe',
  UNSUBSCRIBE_NOTIFICATION: '/notifications/unsubscribe',
  TEST_PUSH_NOTIFICATION: '/notifications/test-push',
  GET_VAPID_PUBLIC_KEY: '/notifications/public-key',

  FORGOT_PASSWORD: 'auth/reset-password/request',
  RESET_PWD: 'auth/reset-password',

  /** user management */
  GET_LIST_USERS: '/users',
  CREATE_USER: '/users',
  GET_ROLES_USER: '/users/roles',
  UPDATE_USER: '/users',
  DELETE_USER: '/users',
  CHANGE_LOCALE_USER: '/users/change-language',
  EXPORT_USERS: '/users/export',

  /** Change password */
  CHANGE_PASSWORD: (userId: string) => `/users/${userId}/change-password`,

  /** Upload files */
  GET_UPLOAD_LINK: `/files/upload-link`,
  SAVE_UPLOAD_INFORMATION: `/files`,

  /** Chat */
  GET_READ_TOKEN: '/files/read-token',
  GET_CONVERSATIONS: '/conversations',
  GET_LATEST_CONVERSATION: '/conversations/latest',
  GET_LATEST_MESSAGE_CONVERSATION: '/conversations/histories/lastest',
  EDIT_CONVERSATION_NAME: '/conversations',
  DELETE_CONVERSATIONS: '/conversations',
  GET_DETAIL_CONVERSATION: '/conversations/histories',
  ADD_QUESTION: '/conversations/message',
  EDIT_QUESTION: '/conversations/message',
  LIST_SUPPORTED_MODEL: '/conversations/list_supported_model',

  /** Summary */
  GET_TASKS: '/summaries',
  GET_LATEST_TASK: '/summaries/latest',
  GET_LATEST_MESSAGE_SUMMARY: '/summaries/histories/lastest',
  EDIT_TASK_NAME: '/summaries',
  DELETE_TASKS: '/summaries',
  GET_DETAIL_TASK: '/summaries/histories',
  ADD_QUESTION_SUMMARY: '/summaries/message',
  EDIT_QUESTION_SUMMARY: '/summaries/message',

  /** Translation */
  GET_TRANSLATION_TASKS: '/translation',
  GET_LATEST_TRANSLATION_TASK: '/translation/latest',
  EDIT_TRANSLATION_TASK_NAME: '/translation',
  DELETE_TRANSLATION_TASKS: '/translation',
  GET_DETAIL_TRANSLATION_TASK: '/translation/detail',
  ADD_TRANSLATION_TASK: '/translation',
  EDIT_TRANSLATION_TASK: '/translation',
  DOWNLOAD_TRANSLATED_FILES: '/translation/download',

  /** Languages */
  GET_LIST_LANGUAGES: '/language',

  /** Document */
  GET_FILES: '/files',
  DELETE_FILES: '/files',

  /** Terms of Service */
  GET_TERMS_OF_SERVICE_STATUS: '/organization/term',
  UPDATE_TERMS_OF_SERVICE_STATUS: '/organization/term',

  /** Organization */
  GET_ORGANIZATIONS: '/organization',
  DELETE_ORGANIZATION: '/organization-deletion',
  CREATE_ORGANIZATION: '/organization',
  UPDATE_ORGANIZATION_LIMITATIONS: '/organization',

  TERM_OF_SERVICE_JA_LANGUAGE:
    'https://amatriumgptalllogo.blob.core.windows.net/term-of-service/JP_Amatrium%20-%20Terms%20of%20Service%20-%207Mar2024%20-%20Amatrium%20GPT.pdf',
  TERM_OF_SERVICE_ZH_LANGUAGE:
    'https://amatriumgptalllogo.blob.core.windows.net/term-of-service/zh-Hans_Amatrium%20-%20Terms%20of%20Service%20-%207Mar2024%20-%20Amatrium%20GPT.pdf',
  TERM_OF_SERVICE_DE_LANGUAGE:
    'https://amatriumgptalllogo.blob.core.windows.net/term-of-service/de_Amatrium%20-%20Terms%20of%20Service%20-%207Mar2024%20-%20Amatrium%20GPT.pdf',
  TERM_OF_SERVICE_NL_LANGUAGE:
    'https://amatriumgptalllogo.blob.core.windows.net/term-of-service/nl_Amatrium%20-%20Terms%20of%20Service%20-%207Mar2024%20-%20Amatrium%20GPT.pdf',
  TERM_OF_SERVICE_ES_LANGUAGE:
    'https://amatriumgptalllogo.blob.core.windows.net/term-of-service/es_Amatrium%20-%20Terms%20of%20Service%20-%207Mar2024%20-%20Amatrium%20GPT.pdf',
  TERM_OF_SERVICE_FR_LANGUAGE:
    'https://amatriumgptalllogo.blob.core.windows.net/term-of-service/fr_Amatrium%20-%20Terms%20of%20Service%20-%207Mar2024%20-%20Amatrium%20GPT.pdf',
  TERM_OF_SERVICE_PT_LANGUAGE:
    'https://amatriumgptalllogo.blob.core.windows.net/term-of-service/pt_Amatrium%20-%20Terms%20of%20Service%20-%207Mar2024%20-%20Amatrium%20GPT.pdf',
  TERM_OF_SERVICE_AR_LANGUAGE:
    'https://amatriumgptalllogo.blob.core.windows.net/term-of-service/ar_Amatrium%20-%20Terms%20of%20Service%20-%207Mar2024%20-%20Amatrium%20GPT.pdf',

  /** SyncSharepoint */
  CREATE_CONNECTION: '/azure-connection',
  COMFIRM_CONNECTION: '/azure-connection/confirm/',
  GET_ALL_CONNECTIONS: '/azure-connection',
  DELETE_CONNECTION: '/azure-connection/id/',
  REDIRECT_SHAREPOINT: '/sync-sharepoint?connection_id=',
  GET_ALL_PROJECTS_SYNCHRONIZATION: (connection_id: string) =>
    `/azure-synchronization/${connection_id}/sites`,
  SYNCHRONIZE_HISTORY: '/azure-synchronization/histories',
  DELETE_SYNCHRONIZATION: (sync_id: string) => `/azure-synchronization/histories/${sync_id}`,

  GET_ALL_DOCUMENTS_BY_PROJECT: (connection_id: string) =>
    `/azure-synchronization/${connection_id}/items`,

  POST_SYNCHRONIZATION: (connection_id: string) => `/azure-synchronization/${connection_id}/sync`,

  CREATE_SYNCHRONIZATION: (connection_id: string) => `/azure-synchronization/${connection_id}/sync`,
};
